import L10n from "../common/L10n";
import { ICategory } from '../interface/ICategory';
import store from "../store/Store";

export default class ServerSelect {

    private sel: HTMLSelectElement | null = null;
    private optList: NodeListOf<HTMLSelectElement> | undefined;

    public draw(_sList: ICategory[]){
        if (!store.CommonDataStore.config.useCategorySelect) return;

        const el: HTMLElement|null = document.querySelector('.history-year .dropdown-wrap.server-sel');
        if (el) {
            el.innerHTML =  `
            <div class="dropdown dropdown-selectmenu">
                <select name="st">
                    <option value="ALL">${L10n.allserver}</option>
                    ${_sList.map(item => `
                        <option value="${item.id}">${item.name}</option>
                    `).join('')}
                </select>
            </div>`; 
        }


        this.sel = document.querySelector('.history-year .dropdown-wrap.server-sel select');
        this.optList = document.querySelectorAll('.history-year .dropdown-wrap.server-sel select option');

        this.addEvents();
    }

    private addEvents(){
        this.sel?.addEventListener('change', e=>{
            window.location.href = `#!/${store.CommonDataStore.nowYear}/${this.sel?.value}`;
        });
    }

    public update(_year: string, _server: string){
        if (!store.CommonDataStore.config.useCategorySelect) return;
        
        this.optList?.forEach( (item: HTMLSelectElement)=>{
            if(item.value === _server){ 
                item.setAttribute('selected', '')
            }else {
                item.removeAttribute('selected');
            }
        });
    }

} // end of class